// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"64":"5875e1c6507ee087","91":"f749f75ab4f4911c","185":"f88ce6b3a078e6c4"}[chunkId] + ".css";
};